import Vue from "vue";
import _ from "lodash";

String.prototype.replaceAt = function(index, replacement, replacedLength) {
  return (
    this.substr(0, index) + replacement + this.substr(index + replacedLength)
  );
};

const colorTextWrapper = {
  install(Vue) {
    Vue.filter("colorTextWrapper", function(value, search) {
      if (typeof value == "string") {
        let replaced = value;
        _.replace(
          _.toLower(_.deburr(`${value}`)),
          _.toLower(_.deburr(`${search}`)),
          function(i, j) {
            replaced = value.replaceAt(
              j,
              `<span class='primary--text'>${value.slice(
                j,
                search.length + j
              )}</span>`,
              search.length
            );
          }
        );

        return replaced;
      } else {
        return value;
      }
    });
  }
};

Vue.use(colorTextWrapper);
